export const styleObject = {
  base: {
    color: "black",
    fontSize: "16px",
    fontSmoothing: "antialiased",
    fontFamily: "Helvetica",
    fontWeight: 200,
  },
  error: {
    color: "#cb1a33", // TODO: Find color
  },
  placeholder: {
    color: "#777",
  },
  validated: {
    color: "#000000",
  },
};

export type AdyenStyleObject = typeof styleObject;
